import { takeLatest, takeEvery, fork, call, put } from "redux-saga/effects";
import { SCORECARD_ACTIONS } from "constants/actions";
import { ScoreCardService } from "services";
import { message } from "antd";
import {
    fetchedScoreCard,
    failedFetchScoreCard,
    failedGenerateScoreCard,
    generatedScoreCard
} from "store/actions";

export function* fetchScoreCard({ payload: { case_id, scorecard_type } }) {
    try {
        const { data, error } = yield call(
            ScoreCardService.getScoreCard,
            case_id,
            scorecard_type
        );
        if (error) {
            yield put(failedFetchScoreCard(case_id, error));
        } else {
            yield put(fetchedScoreCard(case_id, scorecard_type, data));
        }
    } catch (error) {
        yield put(failedFetchScoreCard(case_id, error));
    }
}

export function* generateScoreCard({ payload: { case_id, scorecard_type } }) {
    try {
        const { error: generateError } = yield call(
            ScoreCardService.generateScoreCard,
            case_id,
            scorecard_type
        );
        if (!generateError) {
            yield put(generatedScoreCard(case_id, scorecard_type));
            yield* fetchScoreCard({
                payload: {
                    case_id,
                    scorecard_type
                }
            });
        } else {
            yield put(failedGenerateScoreCard(case_id));
        }
    } catch(error) {
        message.error("Failed to Generate Scorecard");
        yield put(failedGenerateScoreCard(case_id));
    }
}

export default fork(function*() {
    yield takeEvery(SCORECARD_ACTIONS.FETCH_SCORECARD, fetchScoreCard);
    yield takeLatest(SCORECARD_ACTIONS.GENERATE_SCORECARD, generateScoreCard);
});
